import { injectable } from "inversify";   
import ITokenEncoder from "./ITokenEncoder";  
import { SignJWT, JWTPayload } from "jose"; 

@injectable()
export default class TokenEncoder implements ITokenEncoder{ 

   async Encode(kid: string, secret: string, token: JWTPayload): Promise<string> {  
      return await new SignJWT({...token})
        .setProtectedHeader({ alg: 'HS256', kid: kid })
        .setExpirationTime('1h')
        .setIssuedAt()
        .sign(new TextEncoder().encode(secret)); 
    }
}